module.exports = function() {
  return new Worker(__webpack_public_path__ + "c60ab718c22ea959ff4c.worker.js");
};